export const UNASSIGNED_USER_GROUP_ID = 'unassigned' as const;
